<form [formGroup]="formGroup" class="grid-container">
  <div class="grid-x">
    <div class="cell large-3 bold">
      Date / Time of Request:
    </div>
    <div class="cell large-3">
      {{ requestTime | date: 'MMMM d, y, h:mm a'}}
    </div>
    <div class="cell large-3 bold" [ngClass]="{ 'red': dateInvalid }">
      Date DOGRM Received Document:*
    </div>
    <div class="cell large-3">
      <common-date-picker [id]="'receivedDate'" (dateUpdated)="receivedDateChanged($event)"></common-date-picker>
    </div>
    <div class="cell large-3 bold select-lines" [ngClass]="{ 'red': groupInvalid }">
      *Group Making the Request:
    </div>
    <div class="cell large-3 padding-right select-lines">
      @if (departments.length !== 0) {
        <select formControlName="group">
          @for (group of departments; track group) {
            <option [value]="group.id">{{group.displayName}}</option>
          }
        </select>
      }
      <text-loader [run]="departments.length === 0" [text]="'Loading Groups'" [tickType]="'.'" [interval]="2000"></text-loader>
    </div>
    <div class="cell large-2 bold select-lines" [ngClass]="{ 'red' : formGroup.get('requestor').invalid }">
      *Requestor:
    </div>
    <div class="cell large-4 select-lines">
      @if (groups.length !== 0) {
        <select formControlName="requestor">
          @for (group of groups; track group) {
            <option [value]="group.id">{{group.displayName}}</option>
          }
        </select>
      }
      <text-loader [run]="groups.length === 0" [text]="'Loading Groups'" [tickType]="'.'" [interval]="2000"></text-loader>
    </div>
  </div>
  @if (documentArray != null) {
    <div class="grid-x">
      <div class="cell large-12 bold padding-bottom">
        Document Details @if (!paperApplication) {
        <span class="italic padding-left-large">Each document needs to be scanned individually.</span>
        } @if (enableMultiple) {
        <button (click)="addDocument()"><svg-icon icon="icon-plus" class="tiny black"></svg-icon></button>
      }
    </div>
    @for (document of documentArray.controls; track document; let i = $index) {
      <div class="cell large-12" formArrayName="documents">
        <scan-document-details [formGroup]="document" [formGroupName]="i" [generatedApplicationNumber]="applicationNumber" [groupName]="i" [organization]="organization" [paperApplication]="paperApplication"></scan-document-details>
      </div>
    }
  </div>
}
<div class="grid-x">
  <div class="cell large-12 bold">
    Notes / Instructions:
  </div>
  <div class="cell large-12">
    <textarea formControlName="instructions"></textarea>
  </div>
</div>
<div class="grid-x">
  <div class="cell large-12 text-align-center">
    <span class="minor-margin-right">
      <button class="button" (click)="print()" [disabled]="formGroup.invalid || !docFormsValid">Print</button>
    </span>
    <span class="minor-margin-right">
      <button class="button" (click)="submit()" [disabled]="formGroup.invalid || !docFormsValid">Submit</button>
    </span>
    <span>
      <button class="button" (click)="cancel()">Cancel</button>
    </span>
  </div>
</div>
</form>
<a style="display: none;" href="" target="_blank" #downloadLink rel="noopener noreferrer">Download</a>